import { Tooltip } from 'antd'
import { ReactNode } from 'react'
import { useChilizConfigProvider } from '../stores'

const getAnchorForHash = ({ explorerUrl, hash, title, type }): JSX.Element => (
  <a target="_blank" rel="noreferrer" href={`${explorerUrl as string}${type as string}/${hash as string}`}>{title}</a>
)

interface IExplorerLinkProps {
  hash: string
  truncate?: boolean
  type?: string
  customTitle?: ReactNode
}

export const ExplorerLink = ({ hash, truncate = false, type = 'tx', customTitle }: IExplorerLinkProps): JSX.Element => {
  const configProvider = useChilizConfigProvider()
  const { explorerUrl } = configProvider.getChainConfig()
  if (customTitle !== undefined) return getAnchorForHash({ explorerUrl, hash, title: customTitle, type })
  if (truncate) {
    return (
      <Tooltip title={hash}>
        {getAnchorForHash({ explorerUrl, hash, title: hash.slice(0, 8) + '...', type })}
      </Tooltip>
    )
  } else {
    return getAnchorForHash({ explorerUrl, hash, title: hash, type })
  }
}
